import React from 'react';
import { User, Phone, FileText, AlertCircle, UserCheck } from 'lucide-react';

const CandidatDetails = ({ candidat, getStatusColor, getStatusLabel }) => {
  if (!candidat) return null;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <User className="h-5 w-5 mr-2 text-blue-600" />
            Informations personnelles
          </h4>
          <div className="space-y-2 text-sm bg-gray-50 p-4 rounded-lg">
            <p><span className="font-medium">Nom complet:</span> {candidat.nom_complet}</p>
            <p><span className="font-medium">Numéro candidat:</span> {candidat.numero_candidat}</p>
            <p><span className="font-medium">Date de naissance:</span> {new Date(candidat.date_naissance).toLocaleDateString('fr-FR')}</p>
            <p><span className="font-medium">Lieu de naissance:</span> {candidat.lieu_naissance}</p>
            <p><span className="font-medium">Sexe:</span> {candidat.sexe === 'M' ? 'Masculin' : 'Féminin'}</p>
            <p><span className="font-medium">Nationalité:</span> {candidat.nationalite}</p>
            <p><span className="font-medium">Âge:</span> {candidat.age} ans</p>
          </div>
        </div>

        <div>
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <Phone className="h-5 w-5 mr-2 text-green-600" />
            Contact
          </h4>
          <div className="space-y-2 text-sm bg-gray-50 p-4 rounded-lg">
            <p><span className="font-medium">Téléphone:</span> {candidat.telephone}</p>
            <p><span className="font-medium">Email:</span> {candidat.email}</p>
            <p><span className="font-medium">Adresse:</span> {candidat.adresse}</p>
          </div>
        </div>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
          <FileText className="h-5 w-5 mr-2 text-orange-600" />
          Concours
        </h4>
        <div className="space-y-2 text-sm bg-gray-50 p-4 rounded-lg">
          <p><span className="font-medium">Session:</span> {candidat.session_concours?.nom}</p>
          <p><span className="font-medium">Type:</span> {candidat.session_concours?.type_concours?.nom}</p>
          <p><span className="font-medium">Statut:</span> 
            <span className={`ml-2 inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(candidat.statut_inscription)}`}>
              {getStatusLabel(candidat.statut_inscription)}
            </span>
          </p>
          <p><span className="font-medium">Date d'inscription:</span> {new Date(candidat.date_inscription).toLocaleDateString('fr-FR')}</p>
          
          {candidat.note_finale && (
            <>
              <p><span className="font-medium">Note finale:</span> {candidat.note_finale}/20</p>
              {candidat.rang && (
                <p><span className="font-medium">Rang:</span> {candidat.rang}</p>
              )}
              <p><span className="font-medium">Admis:</span> 
                {candidat.admis ? (
                  <span className="ml-2 text-green-600 font-semibold">Oui</span>
                ) : (
                  <span className="ml-2 text-red-600 font-semibold">Non</span>
                )}
              </p>
            </>
          )}
        </div>
      </div>

      {candidat.documents && candidat.documents.length > 0 && (
        <div>
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <FileText className="h-5 w-5 mr-2 text-gray-600" />
            Documents
          </h4>
          <div className="space-y-1 bg-gray-50 p-4 rounded-lg">
            {candidat.documents.map((doc, index) => (
              <div key={index} className="flex items-center text-sm">
                <FileText className="h-4 w-4 mr-2 text-gray-400" />
                <span>{doc.nom_document}</span>
                {doc.valide ? (
                  <UserCheck className="h-4 w-4 ml-2 text-green-600" />
                ) : (
                  <AlertCircle className="h-4 w-4 ml-2 text-yellow-600" />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CandidatDetails;